import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import beseurl from './utils/index'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'
import Fragment from 'vue-fragment'
import * as echarts from 'echarts'

import VueClipboard from 'vue-clipboard2'
import {Message} from 'element-ui'
Vue.use(VueClipboard)
const showStatus = (status) => {
  let message = ''
  switch (status) {
      case 400:
          message = '请求错误(400)'
          break
      case 401:
          message = '此账户可能已在别处登录，请重新登录'
          break
      case 403:
          message = '拒绝访问(403)'
          break
      case 404:
          message = '请求出错(404)'
          break
      case 408:
          message = '请求超时(408)'
          break
      case 500:
          message = '服务器错误(500)'
          break
      case 501:
          message = '服务未实现(501)'
          break
      case 502:
          message = '网络错误(502)'
          break
      case 503:
          message = '服务不可用(503)'
          break
      case 504:
          message = '网络超时(504)'
          break
      case 505:
          message = 'HTTP版本不受支持(505)'
          break
      default:
          message = `连接出错(${status})!`
  }
  return `${message}，请检查网络或联系管理员！`
}

const $http = axios.create({
  //   baseURL: process.env.VUE_APP_TITLE,
    baseURL: beseurl,
    headers: {
        get: {
            'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
        },
        post: {
            'Content-Type': 'application/json;charset=utf-8'
        }
    },
    timeout: 100000*20
  })
  $http.interceptors.request.use((config) => {

      config.headers.token=sessionStorage.getItem('user_token')?sessionStorage.getItem('user_token'):"";
      return config
      }, (error) => {
        console.log(11111,error);

        return Promise.resolve(error)
      },
    )
  $http.interceptors.response.use((config)=>{
    //   console.log(11111,config);
      const status = config.status
      //    console.log("请求返回状态：",config.data.code)
      let msg = '';
      let that=this
      if (status !== 200) {       
            // 处理http错误，抛到业务代码
          msg = showStatus(config.data.code); 
          Message.error(msg);        
      } else {      
          if (config.data.code == 401) {
                  // this.$message.success('自动退出系统！')
                  Message.error(config.data.message);
                  localStorage.clear();
                  sessionStorage.clear()
                  // console.log("请求返回状态：",config.data.code)
                  router.push('/index')
              }
          }
           return config.data;
  } ,(error) => {
    return Promise.resolve(error)
  })
  //前台使用的xiaos
const $webhttp = axios.create({
//   baseURL: process.env.VUE_APP_TITLE,
    baseURL: beseurl,
    headers: {
        get: {
            'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
        },
        post: {
            'Content-Type': 'application/json;charset=utf-8'
        }
    },
    timeout: 100000*20
})
$webhttp.interceptors.request.use((config) => {

    config.headers.token=sessionStorage.getItem('web_token')?sessionStorage.getItem('web_token'):"";
    return config
    }, (error) => {
        console.log(11111,error);

        return Promise.resolve(error)
    },
    )
$webhttp.interceptors.response.use((config)=>{
    //   console.log(11111,config);
    const status = config.status
    //    console.log("请求返回状态：",config.data.code)
    let msg = '';
    if (status !== 200) {       
            // 处理http错误，抛到业务代码
        msg = showStatus(config.data.code); 
        Message.error(msg);        
    } else {      
        if (config.data.code == 401) {
                // this.$message.success('自动退出系统！')
                store.commit('islogin',false)
                Message.error(config.data.message);
                localStorage.clear();
                sessionStorage.clear()
                // console.log("请求返回状态：",config.data.code)
                router.push('/')
            }
        }
            return config.data;
} ,(error) => {
    return Promise.resolve(error)
})

Vue.prototype.$http=$http;
Vue.prototype.$webhttp=$webhttp;
Vue.use(Fragment.Plugin)
Vue.use(ElementUI)
Vue.config.productionTip = false
Vue.prototype.$echarts = echarts;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
